<template>
<div>
    <div class="dialogo dialogo_ativo dialogo_medio">
        <div class="dialogo__container">
            <div class="dialogo__cabecalho">
                <h2 class="dialogo__titulo u-margem-inferior-mini">Onde encontrar o número de contrato no boleto</h2>
            </div>

            <div class="dialogo__corpo">
                <div class="grade__linha grade__linha_alinhar-vertical-centro">
                    <img class="comprovante-pagamento" src="/Administracao/Content/images/numero-do-contrato.png" />
                </div>
                <div class="grade__linha">
                    <p>Caso não tenha algum boleto em mãos entre em contato com a Agehab pelo telefone <strong>0800-647-3120</strong> das 8 às 13 horas.</p>
                </div>
            </div>
            <button class="dialogo__botao-fechar" type="button" @click="$emit('fecharModal')" aria-label="Fechar diálogo">
                <i class="far fa-times" aria-label="hidden"></i>
            </button>
        </div>
    </div>
</div>
    
</template>

<script>

export default {
    name:"modalInformacaoDoNumeroDeContrato"    
}
</script>